import { render, staticRenderFns } from "./IndexFreeClinic.vue?vue&type=template&id=067a6ec4&scoped=true&"
import script from "./IndexFreeClinic.vue?vue&type=script&lang=js&"
export * from "./IndexFreeClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a6ec4",
  null
  
)

export default component.exports